import { Checkbox } from 'slab'

interface DeactivatedFilterProps {
  showDeactivated: boolean
  onToggle: () => void
}

export function DeactivatedFilter ({ showDeactivated, onToggle }: DeactivatedFilterProps) {
  return (
    <Checkbox
      checked={showDeactivated}
      onChange={onToggle}
      label='Show deactivated'
    />
  )
}
